import axios from "axios";
import store from "@/store";

const qs = require("qs");

//TODO make dependent on a tab.
//TODO make sure we have only 1 place for changing url (e.g. extracting to process.env)
const apiUrl = process.env.VUE_APP_API_URL_OVERRIDE || window.location.origin;

const xhr = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
    Authorization: localStorage.token ? `Bearer ${localStorage.token}` : null
  }
});

xhr.interceptors.request.use(
  config => {
    if (config.tenant) {
      config.headers["X-Tenant-ID"] = store.getters["AppStore/getTenant"];
    }
    if (config.method === "get") {
      config.params = config.data;
      config.paramsSerializer = params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }
    return config;
  },
  error => {
    // handle the error
    return Promise.reject(error);
  }
);

xhr.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      let redirectUri = new URL(window.location.href);
      redirectUri.searchParams.delete("token");
      window.location = `${apiUrl}/api/autopricing/oauth2/authorize/google?redirect_uri=${redirectUri.href}`;
      return error.response;
    }

    if (error.response.status === 400) {
      store.dispatch("AppStore/setErrorDialogData", error.response.data);
    }

    return Promise.reject(error);
  }
);

export default xhr;
